module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-roman.15aa061f.otf";